import React from 'react';
import { View } from '@shared/components/View';
import { MBHover } from '@shared/components/hover';
import { MBIcon, MBImageURISource } from '@shared/components/image';
import { MBSeparator } from '@shared/components/list';
import { MBText } from '@shared/components/text';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { Colors } from '@shared/styles';
import { Styles } from '../styles';

interface MBPlusButtonActionRowProps {
  title: string;
  icon: MBImageURISource;
  separator?: boolean;
  color?: string;
  onPress: () => void;
}

/*

*/
export function MBPlusButtonActionRow({
  title,
  icon,
  separator,
  onPress,
  color = Colors.v2.purple,
}: MBPlusButtonActionRowProps) {
  return (
    <MBTouchableOpacity onPress={onPress}>
      <MBHover hoverStyle={Styles.plusButtonActionRowHoverBackground}>
        <View row centerVertically padding={1}>
          <MBIcon color={color} source={icon} size="small" noPadding />
          <View padding={0.5} />
          <MBText color={color} numberOfLines={1}>
            {title}
          </MBText>
        </View>
        {!!separator && <MBSeparator />}
      </MBHover>
    </MBTouchableOpacity>
  );
}
